import { get as _get } from "lodash";
import api from "../api";
import * as actions from "../actions";
import { store } from "..";
import parseJwt from "../../utils/parseJWT";


import { addErrorAlert } from "./alertLoadingDispatch";
import { toggleGlobalLoader } from "../actions/session";

const DEFAULT_ERROR_TIMEOUT = 4000;

const dispatchError = (errFunc = () => {}) => {
  store.dispatch(errFunc());
  setTimeout(() => store.dispatch(errFunc), DEFAULT_ERROR_TIMEOUT);
};


export const updateUserDataAfterLogin = token => {
    store.dispatch(actions.user.setToken(token));
    store.dispatch(actions.user.setLoading(false));

    // set the token data
    let token_data = parseJwt(token);

    // set the keys
    token_data.funder_admins = _get(token_data, "funder_adm", []);
    token_data.program_admins = _get(token_data, "pp_adm", []);
    token_data.subdomain_admins = _get(token_data, "sub_adm", []);
    token_data.admin = (token_data.groups || []).includes("admin");
    // dispatch permissions
    store.dispatch(actions.user.updateTokenData(token_data));
    // update google tracking session
    window.gtag('config', 'GA_MEASUREMENT_ID', {
        'user_id': token_data.user_id
    });
    // identify user in Heap analytics
    if (window.heap && token_data.user_data?.email) {
        window.heap.identify(token_data.user_data.email);
        window.heap.addUserProperties({
            name: `${token_data.user_data.first_name || ''} ${token_data.user_data.last_name || ''}`.trim(),
            user_id: token_data.user_id,
            is_admin: token_data.admin || false,
        });
    }
    return token_data;
}

export const loginUser = (data) => {
  store.dispatch(actions.user.setLoading(true));
  store.dispatch(actions.user.setError(false));

  return api
    .post("/auth/token/", data) // @params: username, password
    .then((res) => {
      let token = res.data.access;
      return updateUserDataAfterLogin(token)
    })
};


export const updateUser = (data) => {
  store.dispatch(actions.user.setLoading(true));
  store.dispatch(actions.user.setError(false));

  let state = store.getState();
  console.log("state check", state)
  let {user_id} = state.user.decodedTokenData;

  console.log("dispatching path requesr")

  return api.patch(`/users/${user_id}/`, data)
    .then((res) => {
      store.dispatch(actions.user.setLoading(false));
      return new Promise((resolve) => resolve(res.data));
    })
    .catch((err) => {
      console.error(err);
      store.dispatch(actions.user.setLoading(false));
      dispatchError(actions.user.setError);
      
    });
};

export const pullStates = () => {
  store.dispatch(actions.states.setLoading(true));

  let state = store.getState();
  if (state.states.data.length) {
    return new Promise((resolve) => resolve(state.states.data));
  }

  return api
    .get("/states", {})
    .then((res) => {
      store.dispatch(actions.states.setLoading(false));
      store.dispatch(actions.states.setData(res.data));
    })
    .catch((err) => {
      store.dispatch(actions.states.setLoading(false));
      dispatchError(actions.states.setError);
      return err;
    });
};

export const pullUserProjects = (user_id = 0) => {
  store.dispatch(actions.states.setLoading(true));

  // missing get from redux

  return api
    .get(`/project-leads/?user=${user_id}`, {})
    .then((res) => {
      store.dispatch(actions.states.setLoading(false));
      return new Promise((resolve) => resolve(res.data));
    })
    .catch((err) => {
      store.dispatch(actions.states.setLoading(false));
      dispatchError(actions.states.setError);
      return err;
    });
};
export const pullProjects = (params) => {
  store.dispatch(actions.states.setLoading(true));

  // missing get from redux

  return api
    .get(`/project-leads/`, {...params})
    .then((res) => {
      store.dispatch(actions.states.setLoading(false));
      return new Promise((resolve) => resolve(res.data));
    })
    .catch((err) => {
      store.dispatch(actions.states.setLoading(false));
      dispatchError(actions.states.setError);
      return err;
    });
};

export const deactivateProject = project_id => {

    store.dispatch(actions.states.setLoading(true));

    return api.patch(`/project-leads/${project_id}/`, {is_active: false})
        .then((res) => {
            store.dispatch(actions.states.setLoading(false));
        })
        .catch((err) => {
            store.dispatch(actions.states.setLoading(false));
            dispatchError(actions.states.setError);
            return err;
        });
}



export const pullApplications = (params) => {
    store.dispatch(actions.states.setLoading(true));

    // missing get from redux

    return api
        .get(`/project-applications/`, {...params})
        .then((res) => {
            store.dispatch(actions.states.setLoading(false));
            return new Promise((resolve) => resolve(res.data));
        })
        .catch((err) => {
            store.dispatch(actions.states.setLoading(false));
            dispatchError(actions.states.setError);
            return err;
        });
}




export const lookupUsers = (search_str) => {

    store.dispatch(actions.states.setLoading(true));

    return api
        .get(`/user-lookup/`, {q: search_str})
        .then((res) => {
            store.dispatch(actions.states.setLoading(false));
            return new Promise((resolve) => resolve(res.data));
        })
        .catch((err) => {
            store.dispatch(actions.states.setLoading(false));
            dispatchError(actions.states.setError);
            return new Promise((resolve, reject) => reject(err));
        })
}